import { useEffect, useState } from 'react';
import { loadImage, preloadImage } from '../images.ts';

export const usePreloadAssets = (
  importantResources: string[],
  lazyResources: string[],
  conditionalResources: string[] = [],
) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // добавляем ресурсы в html в <link preload />
    [...importantResources, ...lazyResources, ...conditionalResources].forEach(
      preloadImage,
    );

    // ждем когда будут загружены важные ресурсы
    const requests = [...importantResources, ...conditionalResources].map(loadImage);
    Promise.all(requests).then(() => setLoaded(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loaded;
};
